/**
 * UniversalFile Core Types - The Foundation
 *
 * All essential types for the .ud format, extracted and refined
 * from UniversalDesktop v2.1 for pure standalone usage.
 */
/**
 * Raimund's authentic German item type system (0-12)
 * Preserving the original German philosophy with English aliases
 */
export var ItemType;
(function (ItemType) {
    ItemType[ItemType["VORTEX"] = 0] = "VORTEX";
    ItemType[ItemType["KONSTRUKTOR"] = 1] = "KONSTRUKTOR";
    ItemType[ItemType["TABELLE"] = 2] = "TABELLE";
    ItemType[ItemType["FLUSS"] = 3] = "FLUSS";
    ItemType[ItemType["INIT"] = 4] = "INIT";
    ItemType[ItemType["EIGENSCHAFT"] = 5] = "EIGENSCHAFT";
    ItemType[ItemType["FUNKTION"] = 6] = "FUNKTION";
    ItemType[ItemType["EREIGNIS"] = 7] = "EREIGNIS";
    ItemType[ItemType["NOTIZZETTEL"] = 8] = "NOTIZZETTEL";
    ItemType[ItemType["DATABASE"] = 9] = "DATABASE";
    ItemType[ItemType["SYSTEM"] = 10] = "SYSTEM";
    ItemType[ItemType["AI_AGENT"] = 11] = "AI_AGENT";
    ItemType[ItemType["QUANTUM_STATE"] = 12] = "QUANTUM_STATE";
    // English aliases for compatibility
    ItemType[ItemType["VARIABLE"] = 8] = "VARIABLE";
    ItemType[ItemType["NOTE"] = 8] = "NOTE";
    ItemType[ItemType["DOCUMENT"] = 8] = "DOCUMENT"; // Alias for NOTIZZETTEL
})(ItemType || (ItemType = {}));
/**
 * German type names mapping for authentic output
 */
export const GERMAN_TYPE_NAMES = {
    [ItemType.VORTEX]: 'VORTEX',
    [ItemType.KONSTRUKTOR]: 'KONSTRUKTOR',
    [ItemType.TABELLE]: 'TABELLE',
    [ItemType.FLUSS]: 'FLUSS',
    [ItemType.INIT]: 'INIT',
    [ItemType.EIGENSCHAFT]: 'EIGENSCHAFT',
    [ItemType.FUNKTION]: 'FUNKTION',
    [ItemType.EREIGNIS]: 'EREIGNIS',
    [ItemType.NOTIZZETTEL]: 'NOTIZZETTEL',
    [ItemType.DATABASE]: 'DATABASE',
    [ItemType.SYSTEM]: 'SYSTEM',
    [ItemType.AI_AGENT]: 'AI_AGENT',
    [ItemType.QUANTUM_STATE]: 'QUANTUM_STATE'
    // Note: VARIABLE, NOTE, DOCUMENT are aliases for NOTIZZETTEL (value 8)
    // They will automatically resolve to 'NOTIZZETTEL' when looked up
};
/**
 * Validation error for UD format parsing
 */
export class UDValidationError extends Error {
    errorType;
    itemId;
    lineNumber;
    constructor(message, errorType, itemId, lineNumber) {
        super(message);
        this.errorType = errorType;
        this.itemId = itemId;
        this.lineNumber = lineNumber;
        this.name = 'UDValidationError';
    }
}
//# sourceMappingURL=types.js.map